/**
 * Country dial codes for the phone-number picker (Telegram-style).
 * Iran is first (primary market); the rest are common codes. `iso` matches the
 * country code returned by GET /api/geo/country so we can preselect by IP.
 */
export const COUNTRIES = [
  { iso: 'IR', name: 'Iran',            dial: '+98',  flag: '🇮🇷' },
  { iso: 'US', name: 'United States',   dial: '+1',   flag: '🇺🇸' },
  { iso: 'GB', name: 'United Kingdom',  dial: '+44',  flag: '🇬🇧' },
  { iso: 'AE', name: 'UAE',             dial: '+971', flag: '🇦🇪' },
  { iso: 'TR', name: 'Turkey',          dial: '+90',  flag: '🇹🇷' },
  { iso: 'DE', name: 'Germany',         dial: '+49',  flag: '🇩🇪' },
  { iso: 'FR', name: 'France',          dial: '+33',  flag: '🇫🇷' },
  { iso: 'IT', name: 'Italy',           dial: '+39',  flag: '🇮🇹' },
  { iso: 'ES', name: 'Spain',           dial: '+34',  flag: '🇪🇸' },
  { iso: 'NL', name: 'Netherlands',     dial: '+31',  flag: '🇳🇱' },
  { iso: 'SE', name: 'Sweden',          dial: '+46',  flag: '🇸🇪' },
  { iso: 'NO', name: 'Norway',          dial: '+47',  flag: '🇳🇴' },
  { iso: 'RU', name: 'Russia',          dial: '+7',   flag: '🇷🇺' },
  { iso: 'CA', name: 'Canada',          dial: '+1',   flag: '🇨🇦' },
  { iso: 'AU', name: 'Australia',       dial: '+61',  flag: '🇦🇺' },
  { iso: 'IN', name: 'India',           dial: '+91',  flag: '🇮🇳' },
  { iso: 'CN', name: 'China',           dial: '+86',  flag: '🇨🇳' },
  { iso: 'JP', name: 'Japan',           dial: '+81',  flag: '🇯🇵' },
  { iso: 'KR', name: 'South Korea',     dial: '+82',  flag: '🇰🇷' },
  { iso: 'SA', name: 'Saudi Arabia',    dial: '+966', flag: '🇸🇦' },
  { iso: 'IQ', name: 'Iraq',            dial: '+964', flag: '🇮🇶' },
  { iso: 'QA', name: 'Qatar',           dial: '+974', flag: '🇶🇦' },
  { iso: 'KW', name: 'Kuwait',          dial: '+965', flag: '🇰🇼' },
  { iso: 'OM', name: 'Oman',            dial: '+968', flag: '🇴🇲' },
  { iso: 'BH', name: 'Bahrain',         dial: '+973', flag: '🇧🇭' },
  { iso: 'AF', name: 'Afghanistan',     dial: '+93',  flag: '🇦🇫' },
  { iso: 'PK', name: 'Pakistan',        dial: '+92',  flag: '🇵🇰' },
  { iso: 'AZ', name: 'Azerbaijan',      dial: '+994', flag: '🇦🇿' },
  { iso: 'AM', name: 'Armenia',         dial: '+374', flag: '🇦🇲' },
  { iso: 'GE', name: 'Georgia',         dial: '+995', flag: '🇬🇪' },
  { iso: 'BR', name: 'Brazil',          dial: '+55',  flag: '🇧🇷' },
  { iso: 'MX', name: 'Mexico',          dial: '+52',  flag: '🇲🇽' },
];

export const DEFAULT_COUNTRY = COUNTRIES[0]; // Iran

export function findByIso(iso) {
  if (!iso) return null;
  return COUNTRIES.find(c => c.iso === String(iso).toUpperCase()) || null;
}
